import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
})
export class PhonePipe implements PipeTransform {
    transform(value: string, format?: string) {
        if (!value) {
            return '';
        }

        if (value.length !== 7 && value.length !== 10) {
            return value;
        }

        switch (format) {
            case 'parens':
                return value.length === 10
                    ? `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(6)}`
                    : `${value.substr(0, 3)}-${value.substr(3)}`;
            case 'dash':
                return value.length === 10
                    ? `${value.substr(0, 3)}-${value.substr(3, 3)}-${value.substr(6)}`
                    : `${value.substr(0, 3)}-${value.substr(3)}`;
            default:
                return value;
        }
    }
}
